import { createNextTableContext } from '@core/table';

export const OrdersTableContext = createNextTableContext();
